import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('getProfileApiAccess data:', data)
  return data
}

const getProfileAccessReq = (consumerChannelId: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.getProfileApiAccess,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      consumerChannelId: consumerChannelId,
    },
    responseType: 'text', //To make responseType as string
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getProfileAccessReq }
